export enum Colors {
  primary700 = '#6f7699',
  white = '#ffffff',
  white2 = '#F5F5F7',
  surface300 = '#80818D',
}

export const opacity = {
  p100: 'FF',
  p95: 'F2',
  p90: 'E6',
  p85: 'D9',
  p80: 'CC',
  p75: 'BF',
  p70: 'B3',
  p65: 'A6',
  p60: '99',
  p55: '8C',
  p50: '80',
  p45: '73',
  p40: '66',
  p35: '59',
  p30: '4D',
  p25: '40',
  p20: '33',
  p15: '26',
  p10: '1A',
  p5: '0D',
  p0: '00',
};
